export const getDefaultTipValue = (
  tipPercentage: number,
  defaultTipAmounts: string[]
) => {
  const tipValue = `${tipPercentage}`;
  const isCustom = !defaultTipAmounts.includes(tipValue);
  return { tipValue, isCustom };
};
